import { datadogLogs } from "@datadog/browser-logs";
import { datadogRum } from "@datadog/browser-rum";
import { reactPlugin } from "@datadog/browser-rum-react";

const isDatadogEnabled =
  Boolean(import.meta.env.VITE_DATADOG_CLIENT_TOKEN) &&
  Boolean(import.meta.env.VITE_DATADOG_APPLICATION_ID);

export function initDatadog() {
  if (!isDatadogEnabled || typeof window === "undefined") {
    return;
  }

  const site = import.meta.env.VITE_DATADOG_SITE || "datadoghq.com";
  const service = import.meta.env.VITE_DATADOG_SERVICE || "mndl-27-portfolio";
  const env = import.meta.env.VITE_DATADOG_ENV || import.meta.env.MODE || "production";
  const version = import.meta.env.VITE_APP_VERSION || undefined;
  const sampleRate = Number(import.meta.env.VITE_DATADOG_SESSION_SAMPLE_RATE || 100);
  const replaySampleRate = Number(import.meta.env.VITE_DATADOG_REPLAY_SAMPLE_RATE || 0);

  datadogRum.init({
    applicationId: import.meta.env.VITE_DATADOG_APPLICATION_ID,
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site,
    service,
    env,
    version,
    sessionSampleRate: sampleRate,
    sessionReplaySampleRate: replaySampleRate,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    defaultPrivacyLevel: "mask-user-input",
    plugins: [reactPlugin({ router: true })],
  });

  if (replaySampleRate > 0) {
    datadogRum.startSessionReplayRecording();
  }

  datadogLogs.init({
    clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN,
    site,
    service,
    env,
    version,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error", "warn"],
    forwardReports: "all",
    sessionSampleRate: sampleRate,
  });
}

export { datadogLogs, datadogRum };
